
<div id="kt_app_footer" class="app-footer">
  <div class="app-container d-flex flex-column flex-md-row flex-center flex-md-stack py-3 container-xxl">
    <div  class="text-gray-900 order-2 order-md-1"><br><br><span
        class="text-muted fw-semibold me-1">{{currDate|date:'yyyy'}}©</span><a  
        target="_blank" class="text-gray-800 text-hover-primary">Sacramento County
        District Attorney's Office
        901 G Street, Sacramento, CA 95814</a>
        <br>
        <p><strong>Please Note: all access is logged and monitored</strong></p></div>
    <ul  class="menu menu-gray-600 menu-hover-primary fw-semibold order-1">
      <li  class="menu-item"><a  href="mailto:support@sacda.org"
          target="_blank" class="menu-link px-2">Supported by IT Department</a></li>
      <li  class="menu-item"> <a href="mailto:support@sacda.org" target="_blank" class="menu-link px-2">support{{'@'}}sacda.org</a></li>
      <li  class="menu-item"><a href="tel:9168746577" target="_blank" class="menu-link px-2">(916)874-6577</a></li>
    </ul><!---->
  </div>
</div>
